<template>
  <div class="body">
    <div class="banner-outer">
      <img
        :src="banner0"
        class="banner"
      />
      <img
        :src="btn"
        class="btn"
      />
    </div>
    <div class="banner-outer">
      <img
        :src="banner1"
        class="banner"
      />
      <div class="box-inset">
        <img
          :src="jLogo"
          class="j-logo"
        />
        <div class="title">
          海外で日本の動画が観られる
        </div>
        <div class="min-title">
          日本VPNサービスとセットでご提供、海外で日本のIP制限動画が観られる
        </div>
      </div>
    </div>
    <!-- <div class="activity-logo">
      <div class="logo-inset">
        <div
          class="logo"
          v-for="(n, index) in newsLogo"
          :key="index"
        >
          <img
            :src="n.picUrl"
            @click="linkTo(n.linkUrl)"
          />
        </div>
        <div
          class="logo"
          v-for="(n, index) in newsLogo"
          :key="'+' + index"
        >
          <img
            :src="n.picUrl"
            @click="linkTo(n.linkUrl)"
          />
        </div>
      </div>
      <div class="btn">
        <span>その他の日本の動画アプリ</span>
      </div>
    </div> -->
    <div
      class="banner-outer"
      style="background: #eae9f2;padding-top:50px"
    >
      <img
        :src="msgBg0"
        class="banner1"
      />
      <div class="box-inset">
        <div
          class="title"
          style="color:#3E67B2;font-size:30px;font-family: middle;padding-bottom:8px;"
        >
          海外在住日本人のテレビ視聴のお悩みを解消！
        </div>
        <div
          class="min-title"
          style="color:#222;font-size:25px"
        >
          日本の動画コンテンツが海外で観られない。<br />
          VPN設定の仕方がわからない！使いづらい！
        </div>
      </div>
    </div>
    <div class="msg-box">
      <div class="msg-title">
        海外の自宅は日本のIP環境
      </div>
      <div class="msg-text">
        BOX本体も、WiFiスポットも、日本のIP環境で接続が可能。コロナの巣ごもり生活に、<br />
        ご家族の皆さんが各自で好きな動画をお楽しみいただけます
      </div>
      <div class="msg-block-image">
        <img :src="msgImage0" />
      </div>
      <div class="msg-title" style="color:#000;">
        海外の自宅は日本のIP環境
      </div>
      <div class="msg-text" style="margin-bottom: 80px;">
        BOX本体も、WiFiスポットも、日本のIP環境で接続が可能。<br />
        コロナの巣ごもり生活に、ご家族の皆さんが各自で好きな動画をお楽しみいただけます。
      </div>
      <div class="msg-sub-title">
        海外生活はJ-DIRECT VPNで変わる<br />
        コロナ巣ごもり期間中のリフレッシュに！
      </div>
      <div class="msg-flex-image">
        <div
          class="msg-flex-image-inset"
          v-for="(n, index) in msgImageFlexList"
          :key="index"
        >
          <img :src="n.url" />
          <p>{{ n.msg }}</p>
        </div>
      </div>
      <div class="msg-title" style="color:#000;margin-top:60px;">
        海外生活はJ-DIRECT BOXで変わる
      </div>
      <div class="msg-text" style="margin-bottom:60px;">
        コロナ巣ごもり生活に手軽な娯楽環境を提供いたします。<br />
        リビングで大画面で家族や夫婦で人気動画を見る、部屋で個別に動画を見るなど、<br />
        それぞれのご家庭に最適なエンタメ環境を実現致します。
      </div>
    </div>
    <div
      class="msg-box"
      style="background:#050B24"
    >
      <div
        class="msg-title"
        style="color:#fff;"
      >
        モバイル端末も日本のIP環境
      </div>
      <div
        class="msg-text"
        style="color:#fff;"
      >
        日本のIP環境になったWiFiスポットに接続すれば、モバイル端末でも日本IP制限の動画が観られる
      </div>
      <div class="msg-block-image">
        <img :src="msgImage1" />
      </div>
    </div>
    <div
      class="msg-title"
      style="color:#000;text-align:center;"
    >
      モバイル端末も日本のIP環境
    </div>
    <div
      class="msg-text"
      style="color:#000;text-align:center;margin-bottom:60px;"
    >
      J-DIRECT BOXはWiFiルーター内蔵。BOXから発するWiFi電波につなぐだけで、お手持ち<br />
      のモバイル端末が簡単にVPN接続できます。<br />
      それらの端末でお好みの日本IP制限動画コンテンツが楽しめます。
    </div>
    <div class="price-form">
      <img :src="priceForm" />
    </div>
    <div class="msg-box-2">
      <div class="title">
        無料体験
      </div>
      <div class="min-title">
        QRコードをスキャンして3ヶ月間の無料体験を！
      </div>
      <img :src="msgImage2" />
    </div>
    <div class="msg-box-2">
      <div class="title">
        J-DIRECT 日本IP-VPNの購入方法
      </div>
      <img :src="msgImage3" />
    </div>
  </div>
</template>
<script>
import { banner0, btn, banner1, jLogo, msgBg0, msgImage0, msgImage1, msgImageFlexList, priceForm, msgImage2, msgImage3 } from '../../images/vpn/index'
import { newsLogo } from '../../images/news/index'
export default {
  data () {
    return {
      banner0,
      btn,
      banner1,
      jLogo,
      newsLogo,
      msgImage0,
      msgImage1,
      msgImage2,
      msgImage3,
      msgBg0,
      msgImageFlexList,
      priceForm
    }
  },
  methods: {
    linkTo (url) {
      window.open(url)
    }
  }
}
</script>
<style scoped>
.banner-outer {
  width: 100%;
  position: relative;
  min-width: 1100px;
  margin: 0 auto;
}
.banner {
  width: 100%;
  height: auto;
  display: block;
}
.banner1 {
  width: 1100px;
  margin: 0 auto;
  height: auto;
  display: block;
}
.btn {
  cursor: pointer;
  position: absolute;
  width: 18%;
  bottom: 30%;
  left: 22%;
}
.title,
.min-title {
  text-align: center;
}
.title {
  font-size: 0.4rem;
  font-weight: bold;
  padding-bottom: 8px;
  font-family: middle;
}
.min-title {
  font-size: 0.2rem;
  font-family: light;
}
.j-logo {
  width: 3rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.2rem;
}
.box-inset {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  color: #ffffff;
  box-sizing: border-box;
  padding: 1rem 0;
}
.activity-logo {
  background: #09131c;
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 500px;
  padding: 50px 0;
}
.activity-logo .btn{
  margin-left: 18%;
  width: 509px;
  height: 74px;
  background: #FEFEFE;
  border: 1px solid #000000;
  border-radius: 37px;
  text-align: center;
}
.activity-logo .btn span{
  font-size: 30px;
  font-family: middle;
  font-weight: bold;
  color: #09152F;
  line-height: 74px;
}
@keyframes iconrun {
  0% {
    left: 0px;
  }
  100% {
    left: -3360px;
  }
}
.logo-inset {
  width: 6720px;
  position: absolute;
  left: 0;
  top: 50px;
  animation: iconrun 30s infinite linear;
}
.logo {
  display: inline-block;
  margin: 0 15px;
}
.logo img {
  display: block;
  width: 250px;
  height: 150px;
  cursor: pointer;
}
.logo-inset .logo:nth-child(1),
.logo-inset .logo:nth-child(13) {
  margin-left: 0;
}
.logo-inset .logo:nth-last-child(1),
.logo-inset .logo:nth-child(24) {
  margin-right: 0;
}
.msg-box {
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
  padding-top: 50px;
  text-align: center;
}
.msg-title {
  color: #036ca8;
  font-size: 30px;
  padding-bottom: 8px;
  font-family: middle;
  font-weight: bold;
}
.msg-text {
  font-size: 20px;
  font-family: light;
}
.msg-block-image{
  margin-bottom: 80px;
}
.msg-block-image img {
  display: block;
  width: 1100px;
  margin: 0 auto;
}
.msg-sub-title {
  color: #2eb5e7;
  font-size: 30px;
  font-family: middle;
  font-weight: bold;
  line-height: 45px;
  margin-bottom: 50px;
}
.msg-flex-image {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.msg-flex-image-inset {
  width: 350px;
  font-size: 20px;
  line-height: 35px;
  text-align: center;
  font-family: light;
}
.msg-flex-image-inset img {
  width: 350px;
  display: block;
}
.price-form {
  width: 100%;
  min-width: 1100px;
  background: #ffffff;
}
.price-form img {
  display: block;
  width: 1100px;
  margin: 0 auto;
}
.msg-box-2 {
  width: 100%;
  min-width: 1100px;
}
.msg-box-2 .title {
  font-size: 30px;
  padding-bottom: 8px;
  font-family: middle;
  font-weight: bold;
  color: #01c4d0;
}
.msg-box-2 img {
  display: block;
  width: 1100px;
  margin: 50px auto;
}
.msg-box-2 .min-title {
  font-size: 20px;
  font-family: light;
  font-weight: bold;
}
/* .logo img:nth */
</style>


// WEBPACK FOOTER //
// src/components/vpn/index.vue